import { render, staticRenderFns } from "./HistoricoPaciente.vue?vue&type=template&id=fdb47472"
import script from "./HistoricoPaciente.vue?vue&type=script&lang=js"
export * from "./HistoricoPaciente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports